import { createApp } from 'vue'
import App from './App.vue'
import './js/registerServiceWorker'
import Emitter from 'tiny-emitter';
import { createPinia } from 'pinia';
import * as VueRouter from 'vue-router';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCircleCheck, faCircleXmark, faChevronRight, faChevronLeft, faFile, faUpload, faBars, faAngleDown, faAngleUp, faCircleNotch, faTrashCan, faTriangleExclamation, faSquareCheck, faXmark, faPlus, faFileImport, faFileInvoiceDollar, faFloppyDisk, faLink, faTableCells, faRotate } from '@fortawesome/free-solid-svg-icons'
library.add(faCircleCheck, faCircleXmark, faChevronRight, faChevronLeft, faFile, faUpload, faBars, faAngleDown, faAngleUp, faCircleNotch, faTrashCan, faTriangleExclamation, faSquareCheck, faXmark, faPlus, faFileImport, faFileInvoiceDollar, faFloppyDisk, faLink, faTableCells, faRotate)

// Tailwind CSS
import './css/tailwind.css'

// Create App
const app = createApp(App)

// Set up router - default to previous month
const now = new Date()
let defaultYear = now.getFullYear()
let defaultMonth = now.getMonth() // 0-indexed: 0=Jan, 11=Dec

// Use previous month (getMonth() gives 0-indexed current month, which equals 1-indexed previous month)
// Exception: January (getMonth()=0) -> December (12) of previous year
if (defaultMonth === 0) {
  defaultMonth = 12
  defaultYear = defaultYear - 1
}

const routes = [
    { path: '/overview/:year', component: App },
    { path: '/:year/:month/:ssp', component: App },

    // not found redirects
    { path: '/', redirect: "/" + defaultYear + "/" + defaultMonth + "/AdDefend" },
    { path: '/:year', redirect: "/" + defaultYear + "/" + defaultMonth + "/AdDefend" },
    { path: '/:year/:month', redirect: "/" + defaultYear + "/" + defaultMonth + "/AdDefend" },
]
const router = VueRouter.createRouter({
    history: VueRouter.createWebHistory(),
    routes,
})


// Create Pinia
const pinia = createPinia();

// Configure App
app.config.globalProperties.$msalInstance = {};
app.config.globalProperties.$emitter = new Emitter();
app.component('font-awesome-icon', FontAwesomeIcon)
    .use(pinia)
    .use(router)

router.isReady().then(() => {
    app.mount('#app')
})
